package horcrux.frontend.common.views.collections.navigator

import horcrux.common.api.dtos.types.CollectionID
import horcrux.common.api.dtos.types.CollectionMetadata
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.views.collections.CollectionMetadataByID
import mui.system.PropsWithSx
import mui.system.sx
import react.FC

external interface SingletonCollectionSelectorProps : PropsWithSx {
    var globalAppState: GlobalAppState
    var collectionMetadata: CollectionMetadata
}

val SingletonCollectionSelector: FC<SingletonCollectionSelectorProps> =
    collectionSelector<CollectionID, CollectionMetadata, CollectionMetadataByID>()
        .let { fc ->
            FC { props ->
                fc {
                    this.globalAppState = props.globalAppState
                    this.metadataByID = props.globalAppState.collectionMetadataByIDState.get()
                    this.componentLabelBase = "collection"
                    this.currentMetadataMaybe = props.collectionMetadata
                    this.labelSupplier = { props.collectionMetadata.collectionName.betterToString() }
                    this.onChange = { }
                    this.sx { +props.sx }
                }
            }
        }
